import _ from "lodash";

/**
 * Recursively omits specified keys from an object or array of objects.
 *
 * @param obj - The object or array to process
 * @param keys - Array of key names to omit from the object(s)
 * @returns The processed object with specified keys omitted
 */
export function omitDeep<T>(obj: T, keys: string[]): T {
  if (_.isArray(obj)) {
    return obj.map((item) => omitDeep(item, keys)) as unknown as T;
  } else if (_.isObject(obj)) {
    const omitted = _.omit(
      _.omitBy(obj, (value) => value === undefined),
      keys,
    );
    return _.mapValues(omitted, (value) => omitDeep(value, keys)) as unknown as T;
  }
  return obj;
}
